import "../AddandEditCustomer/AddandEditCustomer.css";

import { CMSCustomer, CMSUser } from "../../../types/CMSTypes";
import React, { useEffect, useState } from "react";

import { CMSService } from "../../../services/CMSService";
import CMSUsers from "../CMSUsers/CMSUsers";
import { useLoader } from "../../../hooks/useLoader";

interface CMSCustomerDetailsModalProps {
  customer: CMSCustomer | null;
  onClose: () => void;
}

const CMSCustomerDetailsModal: React.FC<CMSCustomerDetailsModalProps> = ({
  onClose,
  customer,
}) => {
  const { showLoading } = useLoader();

  const [allUsersData, setAllUsersData] = useState<{
    users: CMSUser[];
    pagination: { hasMore: boolean };
  } | null>(null);

  const getUsersByCustomerId = async () => {
    try {
      showLoading(true);
      const response = await CMSService.getAllUsersByCustomer({
        customerId: customer?.customerId || customer?.id || "",
        page: 1,
      });
      setAllUsersData(response?.data);
      showLoading(false);
    } catch (error) {
      showLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    getUsersByCustomerId();
  }, []);

  return (
    <div className="modal-overlay-add">
      <div className="modal-container-add">
        <div className="modal-header-add">
          <div className="modal-title-add"></div>
          <button className="close-button" onClick={onClose}>
            X
          </button>
        </div>
        <div style={{ maxHeight: "calc(100vh - 100px)", overflow: "auto" }}>
          <CMSUsers
            allUsersData={allUsersData}
            isAdminUser={true}
            initialCalls={getUsersByCustomerId}
            getAllUsersFromServer={() => {}}
            showOnlyTable={true}
            customerId={customer?.customerId}
          />
        </div>
      </div>
    </div>
  );
};

export default CMSCustomerDetailsModal;
